import ServiceAPI from './api'
import { API } from './services/api-service'
import Profile from "@/modules/hub-module/services/profile";
// import User from "@/modules/hub-module/services/user";

import Connection from './connection'
import Socket from './socket'
import OrganisationCollection from './organisation-collection'
import GroupCollection from './group-collection'
import ContentCollection from './content-collection'
import ChatCollection from './chat-collection'
import FeedCollection from './feed-collection'
import NotificationCollection from './notification-collection'

export default {
  install: function (Vue, options) {
    const store = new Vue.observable({
      user: null,
      userAuth: null
    })

    function setUserAuth(data) {
      const { AuthenticationResult, UserSub } = data || {};
      if(!AuthenticationResult?.IdToken) return new Error('Auth failed');

      store.userAuth = {
        ...store.userAuth,
        ...AuthenticationResult,
        Expires: (new Date()).getTime() + (AuthenticationResult.ExpiresIn * 1000),
        UserSub
      };

      if (!store.userAuth) return new Error('Auth failed');
      
      window.localStorage['userAuth'] = JSON.stringify(store.userAuth)
      return store.userAuth
    }

    options = options || {}
    options.client = true
    var api = new ServiceAPI(options, setUserAuth)
    console.log("api",api);

    // var user = null

    Connection.init();

    Vue.prototype.$connection = Connection
    Vue.prototype.$socket = Socket
    Vue.prototype.$organisation = OrganisationCollection;
    Vue.prototype.$group = GroupCollection
    Vue.prototype.$content = ContentCollection
    Vue.prototype.$chat = ChatCollection
    // Vue.prototype.$feed = FeedCollection
    Vue.prototype.$notification = NotificationCollection;

    var hub = {
      authSynced: false,
      ready: false,
      connectionErrors: 0,
      isReady: () => {
        return hub.authSynced
      },
      initialised: async () => {
        while (!hub.authSynced) {
          await new Promise(resolve => setTimeout(resolve, 300))
        }
        return
      },
      init() {
        //Initialise services if userAuth is set
        if (window.localStorage['userAuth']) {
          store.userAuth = JSON.parse(window.localStorage['userAuth'])

          setTimeout(function () {
            hub.authSync()
          }, 1500)
        } else {
          setTimeout(function () {
            hub.authSynced = true
          }, 1000)
        }
      },
      authSync(noInit) {
        return new Promise((resolve, reject) => {
          hub.authSynced = false

          api.get('/session', { ignoreCache: true }).then(async ({ data }) => {
            store.user = data

            //init collections
            if(!noInit) {
              NotificationCollection.init();
              OrganisationCollection.init();
              GroupCollection.init();
              ContentCollection.init();
              ChatCollection.init();
              // FeedCollection.init();
              Socket.init();
            }

            //register for push
            NotificationCollection.registerDevice();

            hub.authSynced = true
            if (hub.onUserChange) hub.onUserChange(store.user)
            resolve(store.user)
          }, err => {
            hub.authSynced = true
            const statusCode = err.response?.status || err.status || 0;
            console.log("SESSION ERROR", statusCode);

            if(statusCode >= 400 && statusCode <= 599) NotificationCollection.deregisterDevice(window.localStorage['userPushEndpoint']);

            Socket.reset();

            reject(err)
          })
        });
      },
      login(details) {
        return new Promise((resolve, reject) => {
          if (!details || !details.username || !details.password) return reject('Username or password is incorrect.')

          api.post('/login', details, { bypassInterceptor: true, ignoreCache: true }).then(({ data }) => {
            console.log("HEY!!!", data);
            const { ChallengeName = "" } = data;

            if(ChallengeName === "NEW_PASSWORD_REQUIRED") return reject(data);

            try {
              setUserAuth(data)
            } catch (error) {
              return reject(error);
            }

            hub.authSync().then(res => {
              resolve(res)
            }, err => {
              console.log("LOGIN ERROR", err.response?.data?.message || err.message)
              reject(err)
            })
          }, err => {
            console.log("LOGIN ERROR", err.response?.data?.message || err.message)
            reject(err)
          })
        });
      },
      logout() {
        delete window.localStorage['userAuth']
        store.userAuth = null
        store.user = null

        window.sessionStorage.clear();
        window.sessionStorage.initialised = true;

        NotificationCollection.deregisterDevice(window.localStorage['userPushEndpoint']);

        Socket.reset();

        if (hub.onUserChange) hub.onUserChange(store.user)
      },
      signup(details) {
        return new Promise((resolve, reject) => {
          if (!details || !details.username || !details.password || !details.firstName || !details.lastName) return reject('All details must be provided.')

          api.post('/signup', details, { bypassInterceptor: true, ignoreCache: true }).then(({ data }) => {
            if (data.CodeDeliveryDetails?.AttributeName === 'email') {
              resolve({
                UserConfirmed: false,
                UserSub: data.UserSub,
                CodeSent: data.CodeDeliveryDetails.AttributeName
              })
            }
          }, err => {
            console.log("SIGNUP ERROR", err.response?.data?.message || err.message)
            reject(err)
          })
        });
      },
      signupConfirm(details) {
        return new Promise((resolve, reject) => {
          if (!details || !details.username || !details.confirmationCode) return reject('All details must be provided.')

          api.post('/signup/confirm', details, { bypassInterceptor: true, ignoreCache: true }).then(({ data }) => {
            if (data) {
              resolve({
                UserConfirmed: true
              })
            }
          }, err => {
            console.log("SIGNUP CONFIRM ERROR", err.response?.data?.message || err.message)
            reject(err)
          })
        });
      },
      requestPasswordReset(details) {
        return new Promise((resolve, reject) => {
          if (!details.username) return reject('All details must be provided.')

          api.post('/forgot', details, { bypassInterceptor: true, ignoreCache: true }).then(({ data }) => {
            if (data.CodeDeliveryDetails?.AttributeName === 'email') {
              resolve({
                UserConfirmed: false,
                UserSub: data.UserSub,
                CodeSent: data.CodeDeliveryDetails.AttributeName
              })
            } else if(data.sent) {
              resolve({
                UserConfirmed: false
              })
            }
          }, err => {
            console.log("FORGOT ERROR", err.response?.data?.message || err.message)
            reject(err)
          })
        });
      },
      passwordResetConfirm(details) {
        return new Promise((resolve, reject) => {
          if (!details || !details.username || !details.confirmationCode || !details.password) return reject('All details must be provided.')

          api.post('/forgot/confirm', details, { bypassInterceptor: true, ignoreCache: true }).then(({ data }) => {
            if (data) {
              resolve({
                ResetConfirmed: true
              })
            }
          }, err => {
            console.log("RESET CONFIRM ERROR", err.response?.data?.message || err.message)
            reject(err)
          })
        });
      },
      getUser() {
        return store.user
      },
      getUserOrganisationRole(organisation) {
        try {
          return store.user.organisationPermissions[organisation?._id || organisation].roles[0];
        } catch (error) {
          return 0;
        }
      },
      getUserGroupRole(group) {
        try {
          return store.user.permissions[group?._id || group].roles[0];
        } catch (error) {
          return 0;
        }
      },
      hasUserGroupPermission(group, permission) {
        try {
          return store.user.permissions[group?._id || group].permissions.includes(permission);
        } catch (error) {
          return false;
        }
      },
      canCreateGroup() {
        return !store.user.limited;
      },
      canCreateContent() {
        // const groups = Object.values(store.user?.permissions || {});
        // return groups.length > 0;
        return true;
      },
      canShareContent(group) {
        return hub.hasUserGroupPermission(group, 302);
      },
      getUserId() {
        return store.user?._id;
      },
      getUserToken() {
        let token = null;

        if(window.localStorage['userAuth']) {
          var userAuth = JSON.parse(window.localStorage['userAuth'])
          token = `${userAuth.TokenType} ${userAuth.IdToken}`
          // console.log("TOKEN",token)
        }

        return token;
      },
      async updateUser(payload) {
        let user = await Profile.update(payload).then(({data}) => data);
        if(!user) throw new Error('Error updating user profile.');
        // Profile.clear();
        // User.clear(this.getUserId());

        GroupCollection.updateUser(user);

        Vue.set(store, "user", {...store.user, ...user});

        return user;
      },
      avatarURL(id,type,params) {
        params = params || {}
        let paramsString = "";
        Object.keys(params).forEach(key => {
          if(!paramsString) paramsString += "?"
          else paramsString += "&"
          paramsString += `${key}=${params[key]}`
        });

        if(!id) return "";
        if(!type) return `${options.apiURL}/get/${id}/public${paramsString}`;
        return `${options.apiURL}/get/${type}/${id}/image/public${paramsString}`;
      },
      getUserAvatarURL() {
        let user = hub.getUser();
        return hub.avatarURL(user?._id, "user");
      },
      api: api
    }

    Socket.use({
      feedCollection: FeedCollection,
      notificationCollection: NotificationCollection,
      organisationCollection: OrganisationCollection,
      groupCollection: GroupCollection,
      chatCollection: ChatCollection,
      connection: Connection,
      authSync: hub.authSync,
      getUser: hub.getUser
    })

    NotificationCollection.use({ userStore: store })

    OrganisationCollection.use({ authSync: hub.authSync })

    GroupCollection.use({ authSync: hub.authSync })

    API.use(hub.api)

    api.interceptors.response.use(function (response) {
      return response;
    }, function (err) {
      //Get the response status
      var status = err.response?.status || err.status

      console.log('auth status', status)
      switch (status) {
        case 401:
          hub.logout()
          break
        case 403:
          // hub.logout()
          break
        case 500:
          // hub.logout()
          break
        default:
          //Some other error
          break
      }

      /////////////////////////////////////////////////////

      return Promise.reject(err);
    })

    Vue.prototype.$hub = hub
    Vue.prototype.$platform = window.parent.APP_PLATFORM || "web"
    Vue.prototype.$mobilePlatform = ["ios","android"].includes(window.parent.APP_PLATFORM || "web");
    Vue.prototype.$isDesktop = () => {
      if(["electron", "macintosh", "windows"].includes(Vue.prototype.$platform)) return true;
      return (window.innerWidth >= 768 && window.innerHeight >= 1024) || (window.innerWidth >= 1024 && window.innerHeight >= 768);
    }
    Vue.prototype.$hasTouch = () => {
      return 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch) || navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0;
    }
    Vue.prototype.$isSystemAdmin = () => (store.user?.systemPermissions?.roles || []).includes(1);
    Vue.prototype.$hasOrganisations = () => Object.values(store.user?.organisationPermissions || {}).length > 0;
    Vue.prototype.$isOrganisationAdmin = () => Object.values(store.user?.organisationPermissions || {}).filter(({roles}) => roles.includes(1)).length > 0;
    Vue.prototype.$hasBetaAccess = () => store.user?.betaAccess || false;
    Vue.prototype.$isSuper = () => store.user?.superUser || false;
  }
}